import { type Explorer, selectLoadedExplorer } from '../../../domain'

import { Usecase } from '../Usecase'

export const initialExplorerState: Explorer = {
    chunks: new Map<never, never>(),

    customTopics: [],
    selectedTopics: [],
    subscriptionResponse: null,

    latestValues: {},
    tailSize: 50,
    isTailing: true,
    tail: [],
}

export abstract class ExplorerUsecase extends Usecase {
    protected static createTail ({ tail, tailSize }: Pick<Explorer, 'tail' | 'tailSize'>): Explorer['tail'] {
        return tail.slice(0, tailSize)
    }

    protected setExplorer (newExplorer: Partial<Explorer>): void {
        const explorer = selectLoadedExplorer(this.getState())
        this.setState({ explorer: { ...explorer, ...newExplorer } })
    }
}
